import sanitizeHtml from 'sanitize-html';

export default function ExportDayService({ service, name }) {
  return (
    <>
      <div className="text-xs font-semibold leading-snug">
        {service?.name ?? name}
      </div>
      {service?.description && (
        <div
          className="mt-0.5 text-2xs leading-snug text-[var(--td-ink-soft)]"
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(service.description),
          }}
        />
      )}
    </>
  );
}
